import { apiGet, apiPatch } from './client';
import type { FundClassification, FundClassificationBatchRequest } from '../types/FundClassification';

export function getFundClassifications(): Promise<FundClassification[]> {
  return apiGet<FundClassification[]>('/api/fund-classifications');
}

export function saveBatchFundClassifications(added: FundClassification[], modified: FundClassification[], deletedIds: number[]): Promise<FundClassification[]> {
  return apiPatch<FundClassificationBatchRequest, FundClassification[]>('/api/fund-classifications/batch', { added, modified, deleted: deletedIds });
}
